'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LoginController = function () {

  /*@ngInject*/
  function LoginController(Auth, $state) {
    _classCallCheck(this, LoginController);

    this.user = {
      name: '',
      email: '',
      password: ''
    };
    this.errors = {
      login: undefined
    };
    this.submitted = false;

    this.Auth = Auth;
    this.$state = $state;
  }

  _createClass(LoginController, [{
    key: 'login',
    value: function login(form) {
      var _this = this;

      this.submitted = true;

      if (form.$valid) {
        this.Auth.login({
          email: this.user.email,
          password: this.user.password
        }).then(function () {
          _this.$state.go('main');
        }).catch(function (err) {
          _this.errors.login = err.message;
        });
      }
    }
  }]);

  return LoginController;
}();

exports.default = LoginController;


// WEBPACK FOOTER //
// ./client/app/account/login/login.controller.js